<app-spinner [isActive]="submitIsActive"></app-spinner>
<div class="modal-body">
  <div class="card">
    <div class="modal-header modal-close">
      <button type="button" class="close" aria-label="Close" (click)="closeModal()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="card-header modal-card-header">
      <h4 class="card-title" id="basic-layout-form">
        {{ (isEditMode ? 'paymentAction.editTitle' : 'paymentAction.createTitle') | translate }}
      </h4>
      <p class="mb-0">{{ 'paymentAction.text' | translate }}</p>
    </div>
    <div class="card-body">
      <div [class]="hasDesktopView ? 'px-3' : 'px-2'">
        <form class="form" #paymentActionForm="ngForm" (ngSubmit)="onSubmit(paymentActionForm)">

          <div class="form-body">
            <h4 class="form-section">
              <i class="ft-cpu"></i> {{ 'paymentAction.detailsHeader' | translate }}
            </h4>

            <!-- Title -->
            <div class="form-group">
              <label for="Title">{{ 'paymentAction.titleFieldLabel' | translate }}</label>
              <input [disabled]="isViewMode" type="text" class="form-control" name="Title" #Title="ngModel"
                     [(ngModel)]="currentObject.Title"
                     (ngModelChange)="onTitleChange()"
                     placeholder="{{'paymentAction.titleFieldPlaceHolder' | translate}}"
                     maxlength="60" required/>
              <small class="form-text text-muted" *ngIf="Title.invalid && (Title.dirty || Title.touched)">
                {{ 'paymentAction.titleInformationText' | translate }}
              </small>
            </div>

            <!-- Unique Slug: editable while creating, fixed once the action exists -->
            <div class="form-group">
              <label for="UniqueSlug">{{ 'paymentAction.uniqueSlugFieldLabel' | translate }}</label>
              <input [disabled]="isEditMode || isViewMode" type="text" class="form-control" name="UniqueSlug"
                     #UniqueSlug="ngModel"
                     [(ngModel)]="currentObject.Slug"
                     (ngModelChange)="onSlugChange($event)"
                     placeholder="{{currentObject.SlugSuggestion ? currentObject.SlugSuggestion : ('paymentAction.uniqueSlugFieldPlaceHolder' | translate)}}"
                     maxlength="45" pattern="^[a-z0-9\-]{1,45}$"/>
              <small class="text-danger d-block" *ngIf="slugIsNotUnique">
                <i class="ft-alert-circle"></i> {{ 'paymentAction.slugNotUniqueMessage' | translate }}
              </small>
              <small class="form-text text-danger"
                     *ngIf="UniqueSlug.errors?.pattern && (UniqueSlug.dirty || UniqueSlug.touched)">
                {{ 'paymentAction.uniqueSlugPatternText' | translate }}
              </small>
              <small *ngIf="isEditMode" class="form-text text-muted">
                {{ 'paymentAction.uniqueSlugInformationText' | translate }}
              </small>
              <small *ngIf="!isEditMode && !isViewMode" class="form-text text-muted">
                {{ 'paymentAction.uniqueSlugCreateInformationText' | translate }}
              </small>
            </div>

            <!-- Description -->
            <div class="form-group">
              <label for="Description">{{ 'paymentAction.descriptionFieldLabel' | translate }}</label>
              <textarea [disabled]="isViewMode"
                        class="form-control"
                        name="Description"
                        #Description="ngModel"
                        [(ngModel)]="currentObject.Description"
                        placeholder="{{'paymentAction.descriptionFieldPlaceHolder' | translate}}"
                        rows="3"
                        required
                        minlength="15"
                        maxlength="155"
                        (input)="descriptionChanged()">
              </textarea>
              <small [hidden]="isViewMode">{{ descriptionLength }}/155</small>
              <small class="form-text text-danger"
                     *ngIf="Description.errors?.required && (Description.dirty || Description.touched)">
                {{ 'paymentAction.descriptionRequiredText' | translate }}
              </small>

              <small class="form-text text-danger"
                     *ngIf="Description.errors?.minlength && (Description.dirty || Description.touched)">
                {{ 'paymentAction.descriptionLengthText' | translate }}
              </small>

              <small class="form-text text-danger"
                     *ngIf="Description.errors?.maxlength && (Description.dirty || Description.touched)">
                {{ 'paymentAction.descriptionLengthText' | translate }}
              </small>
            </div>

            <!-- Remittance Information -->
            <div class="form-group">
              <label
                for="RemittanceInformation">{{ 'paymentAction.remittanceInformationFieldLabel' | translate }}</label>
              <textarea [disabled]="isViewMode"
                        class="form-control"
                        name="RemittanceInformation"
                        #RemittanceInformation="ngModel"
                        [(ngModel)]="currentObject.RemittanceInformation"
                        placeholder="{{'paymentAction.remittanceInformationFieldPlaceHolder' | translate}}"
                        rows="2"
                        required
                        maxlength="140"
                        pattern="^[a-zA-Z0-9\s/?:().,'+-]+$"
                        (input)="remittenceChanged()">
              </textarea>
              <small [hidden]="isViewMode">{{ remittenceLength }}/140</small>
              <small class="form-text text-danger"
                     *ngIf="RemittanceInformation.errors?.required && (RemittanceInformation.dirty || RemittanceInformation.touched)">
                {{ 'paymentAction.remittanceInformationRequiredText' | translate }}
              </small>

              <small class="form-text text-danger"
                     *ngIf="RemittanceInformation.errors?.maxlength && (RemittanceInformation.dirty || RemittanceInformation.touched)">
                {{ 'paymentAction.remittanceInformationLengthText' | translate }}
              </small>

              <small class="form-text text-danger"
                     *ngIf="RemittanceInformation.errors?.pattern && (RemittanceInformation.dirty || RemittanceInformation.touched)">
                {{ 'payment.descriptionAllowedCharactersText' | translate }}
              </small>
            </div>

            <!-- Accept any amount bool -->
            <div class="form-group">
              <label>{{ 'paymentAction.paymentOptionsFieldLabel' | translate }}</label>
              <div class="form-check">
                <input [disabled]="isViewMode" type="checkbox" class="form-check-input" id="randomAmount"
                       name="randomAmount" [(ngModel)]="currentObject.AllowCustomAmount">
                <label class="form-check-label" for="randomAmount">
                  {{ 'paymentAction.randomAmountOption' | translate }}
                </label>
              </div>
            </div>

            <!-- Payment Options -->
            <div class="form-group">
              <label>{{ 'paymentAction.predefinedAmountFieldLabel' | translate }}</label>
              <div *ngFor="let amount of predefinedAmounts; let i = index; trackBy: trackByIndex">
                <div class="input-group mb-1">
                  <div class="input-group-prepend">
                    <span class="input-group-text">€</span>
                  </div>
                  <!-- Input for Euros -->
                  <input [disabled]="isViewMode" type="number" class="form-control col-md-2"
                         [(ngModel)]="predefinedAmounts[i].amount" name="predefinedAmount{{i}}"
                         min="0" max="99999" placeholder="{{ 'paymentAction.amountFieldPlaceHolder' | translate }}"/>
                  <div *ngIf="!isViewMode" class="input-group-append">
                    <span class="input-group-text">,</span>
                  </div>
                  <!-- Input for Cents -->
                  <input [disabled]="isViewMode" type="number" class="form-control col-md-1"
                         [(ngModel)]="predefinedAmounts[i].cents" name="predefinedAmountCents{{i}}"
                         min="0" max="99" placeholder="00"/>
                  <div *ngIf="!isValidAmount(predefinedAmounts[i])" class="text-danger input-group-append">
                    <span class="input-group-text"> {{ 'paymentAction.minimumValueError' | translate }} </span>
                  </div>
                  <div *ngIf="!isViewMode && this.predefinedAmounts?.length !== 1" class="input-group-append">
                    <button class="btn btn-outline-danger" type="button" (click)="removePredefinedAmount(i)">-</button>
                  </div>
                </div>
              </div>

              <!-- Add More Amounts Button -->
              <button *ngIf="predefinedAmounts.length < 3 && !isViewMode" class="btn btn-sm btn-outline-primary mt-2"
                      type="button" (click)="addPredefinedAmount()">
                + {{ 'paymentAction.addAmountOption' | translate }}
              </button>
            </div>

            <!-- Actions -->
            <div class="form-actions">
              <button [hidden]="isReadOnly || isEditMode || isViewMode" class="btn btn-raised btn-warning mr-1"
                      type="button" (click)="resetForm(paymentActionForm)">
                <i class="ft-x"></i> {{ 'buttons.resetText' | translate }}
              </button>
              <button [hidden]="!isEditMode && !isViewMode" class="btn btn-raised btn-info mr-1" type="button"
                      (click)="copyPaymentUrl(currentObject)">
                <i class="ft-link-2"></i> {{ 'paymentActions.copyPaymentActionUrlTitle' | translate }}
              </button>
              <button [hidden]="isReadOnly || isViewMode" [disabled]="!paymentActionForm.valid"
                      class="btn btn-raised btn-primary mr-1" type="submit">
                <i class="ft-check-square"></i> {{ 'buttons.saveText' | translate }}
              </button>
              <button type="button" class="btn btn-secondary btn-raised mr-1" (click)="closeModal()">
                <i class="ft-x-square"></i> {{ 'buttons.closeText' | translate }}
              </button>
            </div>

          </div>
        </form>
      </div>
    </div>
  </div>
</div>
